var h = Object.defineProperty;
var E = (t, e, n) => e in t ? h(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var f = (t, e, n) => (E(t, typeof e != "symbol" ? e + "" : e, n), n);
import m from "axios";
import A from "web3";
class y {
  constructor(e) {
    f(this, "api");
    const n = {
      baseURL: e,
      method: "POST",
      responseType: "json",
      headers: {
        "Content-Type": "application/json"
      }
    };
    this.api = m.create(n);
  }
}
const d = "ALLEVENTS";
function x({
  eventName: t = d,
  options: e,
  jsonInterface: n,
  web3: a
}) {
  const r = t.toUpperCase() === d;
  if (r)
    throw new Error("generateEventOptions: ALLEVENTS unsupported for now");
  const p = r ? {
    name: d,
    jsonInterface: n
  } : n.find((s) => {
    const c = s.type === "event", u = s.name === t, l = s.signature === `0x${t.replace("0x", "")}`;
    return c && (u || l);
  });
  return { topics: g({ event: p, options: e, web3: a }) };
}
function g({
  event: t,
  options: e,
  web3: n
}) {
  const a = e.filter || {};
  let r = [];
  const o = t.name === d;
  if (Array.isArray(e.topics))
    r = e.topics;
  else if (r = [], t && !t.anonymous && !o && r.push(t.signature), !o) {
    const p = t.inputs.filter((i) => i.indexed === !0).map((i) => {
      const s = a[i.name];
      return s ? Array.isArray(s) ? s.map((c) => n.eth.abi.encodeParameter(i.type, c)) : n.eth.abi.encodeParameter(i.type, s) : null;
    });
    r = r.concat(p);
  }
  return r;
}
const I = 1e4, T = "https://rpc.ankr.com/multichain/", L = async ({
  fromBlock: t,
  toBlock: e,
  blockchain: n,
  contract: a,
  web3: r,
  eventName: o,
  filter: p,
  apiUrl: i = T
}) => {
  const { topics: s } = x({
    web3: r,
    eventName: o,
    jsonInterface: a.options.jsonInterface,
    options: {
      fromBlock: t,
      toBlock: e,
      filter: p
    }
  });
  try {
    return await new y(i).api({
      data: {
        id: 1,
        jsonrpc: "2.0",
        method: "ankr_getLogs",
        params: {
          fromBlock: t,
          toBlock: e,
          blockchain: n,
          address: [a.options.address],
          topics: s,
          pageSize: I
        }
      }
    });
  } catch (c) {
    const u = typeof c == "string" ? c : "Unable to get indexed logs";
    throw new Error(u);
  }
}, w = ({
  blockHash: t,
  transactionHash: e,
  logIndex: n
}) => {
  if (!(typeof t == "string" && typeof e == "string" && typeof n == "string"))
    return null;
  const r = A.utils.sha3(
    t.replace("0x", "") + e.replace("0x", "") + n.replace("0x", "")
  );
  return r ? `log_${r.replace("0x", "").substr(0, 8)}` : null;
}, v = ({
  log: t,
  event: e,
  web3: n
}) => {
  var o;
  if (!e.inputs || !e.name)
    throw new Error("There is no such interface");
  const a = [...t.topics];
  a.shift();
  const r = n.eth.abi.decodeLog(e.inputs, t.data, a);
  return {
    event: e.name,
    returnValues: r,
    signature: t.topics[0],
    logIndex: +n.utils.hexToNumber(t.logIndex),
    transactionIndex: +n.utils.hexToNumber(t.transactionIndex),
    transactionHash: t.transactionHash,
    blockHash: t.blockHash,
    blockNumber: +n.utils.hexToNumber(t.blockNumber),
    address: t.address,
    removed: t.removed,
    id: (o = w(t)) != null ? o : "",
    raw: {
      data: t.data,
      topics: t.topics
    }
  };
}, k = async ({
  fromBlock: t,
  toBlock: e,
  blockchain: n,
  contract: a,
  web3: r,
  eventName: o,
  filter: p,
  apiUrl: i
}) => {
  const s = a.options.jsonInterface.find(
    (u) => u.name === o
  );
  if (!s || !s.inputs)
    throw new Error("There is no such interface");
  const { data: c } = await L({
    fromBlock: t,
    toBlock: e,
    blockchain: n,
    contract: a,
    web3: r,
    eventName: o,
    filter: p,
    apiUrl: i
  });
  return c.result.logs.map(
    (u) => v({ web3: r, log: u, event: s })
  );
};
export {
  k as getPastEvents
};
//# sourceMappingURL=index.js.map
